import type { RankedGlobalSearchDestination } from "./globalSearchRank";

export type GlobalSearchResultGroup = {
  key: string;
  breadcrumbs: string[];
  items: RankedGlobalSearchDestination[];
};

export function groupGlobalSearchResults(results: RankedGlobalSearchDestination[]): GlobalSearchResultGroup[] {
  const groups: GlobalSearchResultGroup[] = [];
  const indexByKey = new Map<string, number>();

  for (const result of results) {
    const key = result.breadcrumbs.join(" → ");
    const existing = indexByKey.get(key);
    if (existing === undefined) {
      indexByKey.set(key, groups.length);
      groups.push({ key, breadcrumbs: result.breadcrumbs, items: [result] });
      continue;
    }
    groups[existing]?.items.push(result);
  }

  return groups;
}

export function unionBreadcrumbIndices(items: RankedGlobalSearchDestination[]): number[][] {
  const first = items[0];
  if (!first) return [];

  return first.breadcrumbs.map((_, crumbIndex) => {
    const indices = new Set<number>();
    for (const item of items) {
      for (const index of item.match.breadcrumbIndices[crumbIndex] ?? []) {
        indices.add(index);
      }
    }
    return [...indices].sort((a, b) => a - b);
  });
}
